import { Card, CardActionArea, Grid, Typography } from '@mui/material'
import React from 'react'
import { ModuleSummaryDto } from '../../../Component/Model/Dto/Home/Home';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';

interface IProps {
    item: ModuleSummaryDto.SummaryItem,
    color: string;
    redirectTo?: string;
    logo: string;
    content: string;
    isExternal?: boolean;
}

const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        borderRadius: "0px 0px 30px 0px",
    }
}));

export const InfoCard = (props: IProps) => {
    const history = useHistory();
    const classes = useStyles();
    const renderCards = () => {
        return (
            <Card className={classes.root}>
                <CardActionArea onClick={() => {
                    if (props.redirectTo) {
                        if (props.isExternal) {
                            window.open(props.redirectTo, '_blank');
                            return null;
                        }
                        history.push(props.redirectTo);
                    }
                }}
                    sx={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "0px 0px 30px 0px",
                        border: `2px solid ${props.color}`,
                        "&:hover": {
                            [`& .MuiCardActionArea-focusHighlight`]: {
                                transition: "1s, font-size 0.2s",
                                background: props.color,
                                opacity: 0.2
                            },
                        },
                    }}>
                    <img src={`${process.env.PUBLIC_URL}/img/pattern.png`} alt='LogoImage' style={{
                        borderRadius: "0px 0px 30px 0px",
                        opacity: 0.05,
                        backgroundColor:props.color,
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                    }} />
                    <Grid container padding={1} >
                        <Grid item xs={9}>
                            <Typography variant="h4" color={props.color} >
                                {props.item.title}
                            </Typography>
                            <Typography variant="body2" >
                                {props.content}
                            </Typography>
                        </Grid>
                        <Grid item xs={3} textAlign="center" sx={{ width: 80 }}>
                            <img style={{ height: '30px' }} alt="logo" src={props.logo} />
                        </Grid>
                    </Grid>
                </CardActionArea >
            </Card >
        )
    }

    return (
        <Grid item xs={4} sx={{ height: "100%", borderRadius: "0px 0px 30px 0px", }}>
            {renderCards()}
        </Grid>
    )
}